import logoDark from '@/images/logo-dark.svg';
import logoLight from '@/images/logo-light.svg';
import LogoLaoSocial from '@/svg-icons/Group.svg';
export const WordmarkLogo: React.FC = () => (
  <div>
    <LogoLaoSocial />
  </div>
);

export const IconLogo: React.FC = () => (
  <svg viewBox='0 0 79 79' className='logo logo--icon' role='img'>
    <title>LaoSocial</title>
    <use xlinkHref='#logo-symbol-icon' />
  </svg>
);

export const SymbolLogo: React.FC = () => {
  const isLight = document.body?.classList.contains('theme-mastodon-light') || 
                  (document.body?.classList.contains('theme-system') && window.matchMedia('(prefers-color-scheme: light)').matches);
  const logo = isLight ? logoDark : logoLight;

  return <img src={logo} alt='LaoSocial' className='logo logo--icon' />;
};
